export const $route = () => {
  const route = useRoute()
  return route
}

export const $router = () => {
  const router = useRouter()
  return router
}
